/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import MetaForm from 'shared/ui/components/form-components/MetaForm.vue';

const __vue_script__ = {
    name: 'RegistryEditor',

    components: {
        MetaForm
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        path: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            settings: null,
            fields: null,
            loading: false,
            saving: false,
            isT9nEnabled: false
        };
    },

    watch: {
        path: {
            immediate: true,
            handler() {
                this.loadRegistry();
            }
        }
    },

    methods: {
        async loadRegistry() {
            try {
                if (this.saving) {
                    return;
                }

                this.loading = true;

                this.settings = await this.$services.settings.getSetting(this.event._id, this.path, 0);
                const registry = await this.$services.settings.getRegistrySettings(this.event._id, this.path);
                if (registry._translatable) {
                    this.isT9nEnabled = true;
                    delete registry._translatable;
                }
                const fields = [];
                for (const [key, value] of Object.entries(registry)) {
                    const field = { ...value };
                    field.field = key;
                    fields.push(field);
                }

                this.fields = fields;

            } catch (error) {
                console.error('[RegistryEditor] Error loading registry', error);

                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred', [this.email]).toString(),
                    text: this.$i18n.t('general.try_later', [this.email]).toString(),
                    type: 'error',
                    duration: 15000
                });
            } finally {
                this.loading = false;
            }
        },

        isFormDirty() {
            return get(this.$refs, 'form.$refs.form.flags.dirty', false);
        },

        validate() {
            this.$refs.form.validate();
        },

        async save(newData) {
            try {
                if (this.saving) {
                    return;
                }

                this.saving = true;

                console.debug('[RegistryEditor] New data received', newData);

                await this.$services.settings.saveSetting(this.event._id, this.path, this.$utils.controls.sanitizeForm(newData));
                await this.loadRegistry();

                this.$refs.form.$refs.form.reset();

                this.$notify({
                    group: 'flashes',
                    text: this.$t('general_settings.messages.save_success').toString(),
                    type: 'success',
                    duration: 5000
                });
            } catch (error) {
                console.error('[RegistryEditor] Could not save settings', newData, error);
                this.$services.crashReporting.captureException(error);

                this.$notify({
                    group: 'flashes',
                    title: this.$t('general.error_occurred'),
                    text: this.$t('general_settings.messages.save_failed').toString(),
                    type: 'error',
                    duration: 10000
                });

            } finally {
                this.saving = false;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "registry-editor" },
    [
      _vm._t("title"),
      _vm.fields
        ? _c("meta-form", {
            ref: "form",
            attrs: {
              value: _vm.settings,
              fields: _vm.fields,
              event: _vm.event,
              edit: true,
              "hide-language-selector": true,
              "single-panel": true,
              "translations-key": _vm.isT9nEnabled ? "content" : null,
            },
            on: { valid: _vm.save },
          })
        : _vm._e(),
      _c("secondary-toolbar", [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { disabled: _vm.saving },
            on: { click: _vm.validate },
          },
          [_vm._v(_vm._s(_vm.$t("general.save")))]
        ),
      ]),
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/editors/RegistryEditor.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__